import styled, { css } from 'styled-components'

export const FieldList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
    padding: 0 8px;
`

export const FieldTitle = styled.div<{ required?: boolean }>`
    height: 22px;
    line-height: 22px;
    font-size: 14px;

    position: relative;
    ${({ required }) =>
        required &&
        css`
            &::after {
                content: '*';
                position: absolute;
                top: 0;
                right: -12px;
                color: var(--color-red-500);
            }
        `}
`

export const FieldItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 6px;
`
